/* eslint-disable import/prefer-default-export */
import axios from 'axios';


export const convertVideo = params => axios.post('/videos', params);
